import { SxProps } from "@mui/material"
import { Theme } from "@mui/system"

export const notificationsList: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "360px",
  gap: "16px",
  position: "relative",
  padding: "0",
}

export const notificationsListItem: SxProps<Theme> = {
  gap: "8px",
  maxWidth: "100%",
  height: "40px",
  minHeight: "40px",
  padding: "0",
  backgroundColor: "inherit",
}

export const notificationsListButton: SxProps<Theme> = {
  gap: "8px",
  display: "grid",
  gridTemplateColumns: "24px 1fr 24px",
  maxWidth: "100%",
  height: "100%",
  width: "100%",
  padding: "0 16px",
  margin: "0",
  alignItems: "center",
  color: "var(--Schemes-On-Surface)",
  "&:hover": {
    color: "var(--Schemes-Primary)",
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
    svg: {
      color: "var(--Schemes-Primary)",
    },
  },
  "&:active": {
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
  },
  span: {
    padding: "0",
  },
}

export const notificationsSaveButton: SxProps<Theme> = {
  fontFamily: "Roboto, sans-serif",
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "20px",
  textAlign: "center",
  color: "var(--Schemes-Primary)",
  padding: "10px 16px",
  gap: "8px",
  borderRadius: "100px",
  minHeight: "40px",
  maxWidth: "100%",
  minWidth: "100px",
  ":hover": {
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
  },
}
